import $ from 'jquery'
import { trackEvent } from './utils/analytics'
import { loadFromLocalStorage, saveToLocalStorage } from './utils/localStorageUtils'

const storageKey = 'favourites'

export const getFavourites = () => loadFromLocalStorage(storageKey, [])
export const getFavouriteEventIds = (favourites = getFavourites()) => favourites.map(({ id }) => id)

window.getFavourites = getFavourites

export function initialise() {
  // recalculate favourites rendering upon content change
  $(document).on('ajax.replace', () => {
    setTimeout(() => {
      updateButtonStates()
    }, 1)
  })

  $(document).on('favourites.updated', () => {
    updateButtonStates()
  })

  updateButtonStates()
  bindButtonEvents()
}

function updateButtonStates() {
  const favourites = getFavourites()
  $('[data-event-favourite]').each((i, elem) => {
    const eventId = $(elem).data('event-favourite')
    const sessionId = $(elem).data('session-id')
    const existingFavourite = favourites.find(({ id }) => id == eventId)

    if (sessionId) {
      const existingFavouriteSessionIds = existingFavourite?.sessionIds || []
      if (existingFavouriteSessionIds.includes(sessionId)) {
        if (!$(elem).hasClass('active')) {
          $(elem).addClass('active')
          $(elem)
            .find('svg')
            .html('<use xlink:href="/assets/glyphs/glyphs.svg?cachebust=2024#heart"></use>')
        }
      } else {
        if ($(elem).hasClass('active')) {
          $(elem).removeClass('active')
          $(elem)
            .find('svg')
            .html('<use xlink:href="/assets/glyphs/glyphs.svg?cachebust=2024#heart-outline"></use>')
        }
      }
    } else {
      if (existingFavourite) {
        if (!$(elem).hasClass('active')) {
          $(elem).addClass('active')
          $(elem)
            .find('svg')
            .html('<use xlink:href="/assets/glyphs/glyphs.svg?cachebust=2024#heart"></use>')
        }
      } else {
        if ($(elem).hasClass('active')) {
          $(elem).removeClass('active')
          $(elem)
            .find('svg')
            .html('<use xlink:href="/assets/glyphs/glyphs.svg?cachebust=2024#heart-outline"></use>')
        }
      }
    }
  })
  $('[data-event-favourite-count]').each((i, elem) => {
    const cnt = favourites.length
    $(elem).html(cnt > 9 ? cnt : '0' + cnt)
  })
}

function bindButtonEvents() {
  $(document).on('click', '[data-event-favourite]', evt => {
    const elem = evt.currentTarget
    const eventId = $(elem).data('event-favourite')
    const sessionId = $(elem).data('session-id') || null
    const eventTitle = $(elem).data('event-title')
    toggleFavourite(eventId, eventTitle, sessionId)
  })
}

export function toggleFavourite(eventId, eventTitle, sessionId = null) {
  const favourites = getFavourites()
  let newFavourites = favourites

  const existingFavourite = favourites.find(({ id }) => id == eventId)
  if (sessionId) {
    const favouriteRecord = existingFavourite || { id: eventId, sessionIds: [] }
    if (!favouriteRecord.sessionIds) favouriteRecord.sessionIds = []
    favouriteRecord.sessionIds = favouriteRecord.sessionIds.includes(sessionId)
      ? favouriteRecord.sessionIds.filter(id => id != sessionId)
      : [...favouriteRecord.sessionIds, sessionId]
    if (favouriteRecord.sessionIds.length == 0) {
      trackEvent('Favourites', 'Remove', eventTitle)
      newFavourites = favourites.filter(({ id }) => id != eventId)
    } else {
      trackEvent('Favourites', 'Add', eventTitle)
      newFavourites = existingFavourite
        ? favourites.map(fav => (fav.id === eventId ? favouriteRecord : fav))
        : [...favourites, favouriteRecord]
    }
  } else {
    if (existingFavourite) {
      trackEvent('Favourites', 'Remove', eventTitle)
      newFavourites = favourites.filter(({ id }) => id != eventId)
    } else {
      trackEvent('Favourites', 'Add', eventTitle)
      newFavourites = [...favourites, { id: eventId, sessionIds: [] }]
    }
  }

  saveToLocalStorage(storageKey, newFavourites)
  $(document).trigger('favourites.updated')
}
